import { render, staticRenderFns } from "./googleUserAgreement-2.0-EN.vue?vue&type=template&id=6b40e832&scoped=true&"
import script from "./googleUserAgreement-2.0-EN.vue?vue&type=script&lang=js&"
export * from "./googleUserAgreement-2.0-EN.vue?vue&type=script&lang=js&"
import style0 from "./googleUserAgreement-2.0-EN.vue?vue&type=style&index=0&id=6b40e832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40e832",
  null
  
)

export default component.exports